<template>
  <div class="page">
    <div class="container" v-if="imageSrc && imageSrc != 'failed'">
      <img class="card" :src="imageSrc" :alt="name" />
      <div class="buttons flex justify-center p-2">
        <button class="simple" @click="downloadImage">儲存名片</button>
      </div>
    </div>
    <div v-else-if="imageSrc == 'failed'">
      <div class="my-6 text-red-600">找不到 {{ name }}</div>
      <div>www.chenbro.com</div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import envs from "../envs";
export default defineComponent({
  props: {
    base64: String,
    name: String,
  },
  setup(props) {
    const imageSrc = ref("");
    const name = ref("");

    onMounted(async () => {
      const url = `${envs.BACKEND_URL}/contact/${props.name}`;
      const res = await fetch(url);
      const content = await res.text();
      if (content.startsWith("cannot")) imageSrc.value = "failed";
      else imageSrc.value = res.url;
      if (props.name) name.value = props.name;
    });

    const downloadImage = () => {
      if (imageSrc.value != null) {
        let a = document.createElement("a");
        a.href = imageSrc.value;
        a.download = imageSrc.value;
        a.click();
      }
    };

    return {
      downloadImage,
      name,
      imageSrc,
    };
  },
});
</script>
<style lang="sass" scoped>
.page
  display: flex
  justify-content: center
  align-items: center
  background: #fff

.container
  padding: 10px
  @media screen and (min-width: 768px)
    max-width: 100%
    @media screen and (min-width: 400px)
      max-width: 400px

.card
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)
  margin: 0 0 10px
  width: 100%
  height: 100%
</style>